import { useEffect, useState } from "react";
import { Filters } from './DevicesViewTab'
import { Input, SearchIcon, Dropdown, Button, ThemePrepared, Flex } from "@fluentui/react-northstar";
import {LocationsFilters, DevicesFilters, StatusFilters} from './filters.constant'


interface FilterUsersProps {
    filtersListActive: string[][];
    theme?: ThemePrepared;
    themeString: string;
    onChangeFilters(filters: Filters): void
}

interface DeviceLocationType{
    [key: string]: string
}


const SearchBarFilters = ({ onChangeFilters, filtersListActive, theme, themeString }: FilterUsersProps) => {

    const [term, setTerm] = useState<string>('')
    const [searchDescriptionResult, setSearchDescriptionResult] = useState<string>('')
    const [deviceType, setDeviceType] = useState<DeviceLocationType>({key: DevicesFilters.All, header: DevicesFilters.All})
    const [currentLocation, setCurrentLocation] = useState<DeviceLocationType>({key: LocationsFilters.All, header: LocationsFilters.All})
    const [status, setStatus] = useState<string>(StatusFilters.All)

    useEffect(() => {
        const currentFilters = createFiltersMask(searchDescriptionResult, deviceType?.key, currentLocation?.key, status)
        onChangeFilters(currentFilters)
    }, [searchDescriptionResult, deviceType, currentLocation, status])

    useEffect(() => {
        if (!term) {
            onSearch(term)
        }
    },[term])

    const createFiltersMask = (
        term: string, deviceType: string, location: string, status: string
    ): Filters => {
        const mask = {
            deviceType,
            location,
            term,
            status
        }
        return mask;
    }

    const onSearch = (searchValue: string) => {
        setSearchDescriptionResult(searchValue)
    }

    const clearFilters = () => {
        setCurrentLocation({key: LocationsFilters.All, header: LocationsFilters.All})
        setStatus(StatusFilters.All)
        setDeviceType({key: DevicesFilters.All, header: DevicesFilters.All})
        setTerm('')
    }

    const createDropdownItems = (arr: string[]) => {
        return arr.map(el => ({key: el, header: el === 'others' ? LocationsFilters.Others : el})) 
    }

    const createDeviceTypeItems = (arr: string[]) => {

    const activeDevicesTypes = arr.map(device => {
        const key = device
        const header = device !== DevicesFilters.Others ? device[0].toUpperCase() + device.slice(1) : 'Other types'
        return {key, header}
    })
        return activeDevicesTypes
    }

    const [activeLocations, activeStatuses, activeDevices] = filtersListActive

    const locations = [LocationsFilters.All, ...activeLocations]
    const statuses = [StatusFilters.All, ...activeStatuses]
    const typeDevices = [DevicesFilters.All, ...activeDevices]

    const locationsItem = createDropdownItems(locations)
    const statusItem = createDropdownItems(statuses)
    const devicesItems = createDeviceTypeItems(typeDevices)

    const backgroundFilters = themeString === 'default' ? 'rgb(250, 249, 248)' : theme?.siteVariables.colorScheme.default.background2 

    return (
        <div className="filters-block">
            <Flex>
                <Input
                    variables={{backgroundColor: backgroundFilters}}
                    value={term}
                    fluid
                    icon={<SearchIcon onClick={() => onSearch(term)} />}
                    iconPosition="start"
                    onChange={(_, data) => setTerm(data?.value || '')}
                    onKeyDown={e => e.keyCode === 13 ? onSearch(term) : null}
                />
            </Flex>
            <Flex 
            gap="gap.medium" 
            wrap
            className="dropdown-filters">
                <Dropdown
                    items={devicesItems}
                    highlightFirstItemOnOpen={true}
                    value={deviceType.header}
                    defaultValue={devicesItems[0]}
                    onChange={(_, data) => setDeviceType(data?.value as DeviceLocationType)}
                    variables={{ width: 170, marginLeft: 20, backgroundColor: backgroundFilters }}
                />
                <Dropdown
                    items={locationsItem}
                    highlightFirstItemOnOpen={true}
                    defaultValue={locationsItem[0]}
                    value={currentLocation.header}
                    onChange={(_, data) => setCurrentLocation(data?.value as DeviceLocationType)}
                    variables={{ width: 170, backgroundColor: backgroundFilters}}
                />
                <Dropdown
                    items={statusItem}
                    highlightFirstItemOnOpen={true}
                    defaultValue={statusItem[0]}
                    value={status}
                    onChange={(_, data) => setStatus(data?.searchQuery || '')}
                    variables={{ width: 170, backgroundColor: backgroundFilters }}
                />
                <Button content="Clear filters" 
                onClick={clearFilters}
                />
            </Flex>
        </div>
    )
}

export default SearchBarFilters